<template>
    <div class="background rounded-lg">
        <Block v-if="loading" />
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="dates.typeData" class="ma-3">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>

        <v-tabs v-model="tab">
            <v-tab href="#1">Ver reporte general</v-tab>
            <v-tab href="#2">Ver reporte detallado</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
            <v-tab-item value="1">
                <div>
                    <date-filter
                        @datesSelected="setDates"
                        :search="{ typeData: dates.typeData }"
                        class="item"
                        @filtered-data="dateFilterHandler"
                        :dataToFilter="dataToGrid"
                        :filterEndpoint="$API.inventoryReports.getEarningsGroupByCatAndWeeks"
                        :isFilteredByOutsource="false"
                    />

                    <br />
                    <DxDataGrid
                    class="isScrolledByGeneralFilter"
                    :data-source="dataToGrid"
                    @exporting="onExporting"
                    :paging="{ enabled: false }"
                    style="max-height: 600px"
                    :show-borders="true"
                    >
                    <DxExport :enabled="true" />
                    <DxColumn
                        :group-index="0"
                        data-field="NumeroSemana"
                        caption="Ventas"
                        :calculate-display-value="getCustomCell"
                        :sortOrder="'asc'"
                    />
                    <DxColumn
                        :group-index="1"
                        data-field="BranchName"
                        caption="Sucursal"
                        :calculate-display-value="getCustomCell2"
                        :sortOrder="'asc'"
                    />
                    <!--DxColumn caption="Sucursal" data-field="BranchName" /-->
                    <!--DxColumn caption="N. Semana" data-field="NumeroSemana" /-->
                    <!--DxColumn caption="Fecha inicio" data-field="FechaInicioSemana" /-->
                    <!--DxColumn caption="Fecha fin" data-field="FechaFinSemana" /-->
                    <!--DxColumn caption="Semana" data-field="SemanaFormateada" /-->
                    <DxColumn caption="Familia" cell-template="familyNameCustom" data-field="familyName" />
                    <template #familyNameCustom="{data}"> 
                        {{ data.data.familyName ? data.data.familyName : "DEFINIR CLASE" }}
                    </template>
                    <!--DxColumn caption="Categoria" data-field="categoryName" /-->
                    <!--DxColumn caption="Subcategoria" data-field="subcategoryName" /-->
                    <!--DxColumn caption="Precio sin IVA" data-field="TotalPriceSinIVA" /-->
                    <!--DxColumn caption="IVA" data-field="TotalIVA" /-->
                    <!--DxColumn caption="Costo sin IVA" data-field="CostoTotalSinIVA" /-->
                    <!--DxColumn caption="IVA del costo" data-field="IVATotalCosto" /-->
                    <!--DxColumn caption="Total Costo" data-field="TotalCosto" /-->
                    <DxColumn caption="Total" data-field="TotalGanancia" 
                    :format="{
                            type: 'custom',
                            formatter: function(value) {
                                if (value == null) return '';
                                    return (value < 0 ? '-$' : '$') + Math.abs(value).toFixed(2);
                                }
                            }" 
                        />

                    <DxSummary>
                        <DxGroupItem
                            :align-by-column="alignColumn"
                            column="TotalGanancia"
                            summaryType="sum"
                            :value-format="{
                                type: 'custom',
                                formatter: function(value) {
                                    if (value == null) return '';
                                        return (value < 0 ? '-$' : '$') + Math.abs(value).toFixed(2);
                                    }
                                }"
                            displayFormat="{0}"
                        />
                    </DxSummary>
                    </DxDataGrid>
                </div>
            </v-tab-item>
            <v-tab-item value="2">
                <div>
                    <date-filter
                        @datesSelected="setDatesDetail"
                        :search="{ typeData: dates.typeData }"
                        class="item"
                        @filtered-data="dateFilterHandlerDetail"
                        :dataToFilter="dataToGridDetail"
                        :filterEndpoint="$API.inventoryReports.getEarningsGroupByCatAndWeeksDetail"
                        :isFilteredByOutsource="false"
                    />

                    <br />
                    <DxDataGrid
                    class="isScrolledByGeneralFilter"
                    :data-source="dataToGridDetail"
                    @exporting="onExportingDetail"
                    :paging="{ enabled: false }"
                    style="max-height: 600px"
                    :show-borders="true"
                    >
                    <DxExport :enabled="true" />
                    <DxColumn
                        :group-index="0"
                        data-field="NumeroSemana"
                        caption="Ventas"
                        :calculate-display-value="getCustomCellDetail"
                        :sortOrder="'asc'"
                    />
                    <DxColumn
                        :group-index="1"
                        data-field="BranchName"
                        caption="Sucursal"
                        :calculate-display-value="getCustomCell2Detail"
                        :sortOrder="'asc'"
                    />
                    <DxColumn
                        :group-index="2"
                        data-field="familyName"
                        caption="Familia"
                        :calculate-display-value="getCustomCell3Detail"
                        :sortOrder="'asc'"
                    />
                    <!--DxColumn caption="Sucursal" data-field="BranchName" /-->
                    <!--DxColumn caption="N. Semana" data-field="NumeroSemana" /-->
                    <!--DxColumn caption="Fecha inicio" data-field="FechaInicioSemana" /-->
                    <!--DxColumn caption="Fecha fin" data-field="FechaFinSemana" /-->
                    <!--DxColumn caption="Semana" data-field="SemanaFormateada" /-->
                    <!-- <DxColumn caption="Familia" cell-template="familyNameCustom" data-field="familyName" />
                    <template #familyNameCustom="{data}"> 
                        {{ data.data.familyName ? data.data.familyName : "DEFINIR CLASE" }}
                    </template> -->
                    <!--DxColumn caption="Categoria" data-field="categoryName" /-->
                    <!--DxColumn caption="Subcategoria" data-field="subcategoryName" /-->
                    <!--DxColumn caption="Precio sin IVA" data-field="TotalPriceSinIVA" /-->
                    <!--DxColumn caption="IVA" data-field="TotalIVA" /-->
                    <!--DxColumn caption="Costo sin IVA" data-field="CostoTotalSinIVA" /-->
                    <!--DxColumn caption="IVA del costo" data-field="IVATotalCosto" /-->
                    <!--DxColumn caption="Total Costo" data-field="TotalCosto" /-->
                    <!-- <DxColumn caption="Total" data-field="TotalGanancia" 
                    :format="{
                            type: 'custom',
                            formatter: function(value) {
                                if (value == null) return '';
                                    return (value < 0 ? '-$' : '$') + Math.abs(value).toFixed(2);
                                }
                            }" 
                        /> -->

                        <DxColumn caption="CodProd" data-field="id_item" />
                        <DxColumn caption="Producto" data-field="Producto" />
                        <DxColumn caption="Unidades" data-field="Unidades" />
                        <DxColumn caption="VTA sin IVA" data-field="vta_sin" />
                        <DxColumn caption="VTA con IVA" data-field="vta_con" />
                        <DxColumn caption="Costo" data-field="CostWithIva" />
                        <DxSummary>
                            <DxGroupItem
                                column="vta_sin"
                                :align-by-column="true"
                                summaryType="sum"
                                :value-format="{
                                    type: 'custom',
                                    formatter: function(value) {
                                        if (value == null) return '';
                                            return (value < 0 ? '-$' : '$') + Math.abs(value).toFixed(2);
                                        }
                                    }"
                                displayFormat="{0}"
                            />
                            <DxGroupItem
                                ro
                                column="vta_con"
                                :align-by-column="true"
                                summaryType="sum"
                                :value-format="{
                                    type: 'custom',
                                    formatter: function(value) {
                                        if (value == null) return '';
                                            return (value < 0 ? '-$' : '$') + Math.abs(value).toFixed(2);
                                        }
                                    }"
                                displayFormat="{0}"
                            />
                            <DxGroupItem
                                column="CostWithIva"
                                :align-by-column="true"
                                summaryType="sum"
                                :value-format="{
                                    type: 'custom',
                                    formatter: function(value) {
                                        if (value == null) return '';
                                            return (value < 0 ? '-$' : '$') + Math.abs(value).toFixed(2);
                                        }
                                    }"
                                displayFormat="{0}"
                            />
                        </DxSummary>
                    </DxDataGrid>
                </div>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxExport,
  DxSummary,
  DxGroupItem
} from "devextreme-vue/data-grid";
import DateFilter from "@/components/DateFilter";
import Block from '@/components/Block.vue';
import { printToExcel } from "@/helpers/printToexcel";
export default {
    name: "ServicesProvidedByDoctor",
    components: {
        DxDataGrid,
        DxColumn,
        DxExport,
        DateFilter,
        Block,
        DxSummary,
        DxGroupItem
    },
    props: {
        win: {
        type: Object,
        default: () => ({}),
        },
        reportModule :{
        type: Boolean,
        default: false

        }
    },
    data() {
        return {
            tab: '01',
            loading: false,
            alignColumn: false,
            dataToGrid: [],
            dates: {
                start: null,
                end: null,
                typeData: "01",
            },
            dataToGridDetail: [],
        }
    },
    methods: {
        imprimirDatos(e) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    if (e) {
                        resolve(printToExcel(e, "Reporte de ventas agrupado"));
                    } else {
                        reject(`Error.`);
                    }
                }, 100);
            });
        },
        async onExporting(e) {
            this.alignColumn = true;
            await this.imprimirDatos(e);
            setTimeout(() => {
                this.alignColumn = false;
            }, 100)
        },
        getCustomCell(rowData) {
            return `entre el ${rowData.FechaInicioSemana} y el ${rowData.FechaFinSemana}`;
        },
        getCustomCell2(rowData) {
            return `${rowData.BranchName}`;
        },
        setDates(dates) {
            dates.typeData = this.dates.typeData;
            this.dates = dates;
            this.loading = true;
        },
        dateFilterHandler(filteredData) {
            this.dataToGrid = filteredData.data;
            this.loading = false;
        },
        onExportingDetail(e) {
            printToExcel(e, "Reporte de ventas agrupado detallado");
        },
        getCustomCellDetail(rowData) {
            return `entre el ${rowData.FechaInicioSemana} y el ${rowData.FechaFinSemana}`;
        },
        getCustomCell2Detail(rowData) {
            return `${rowData.BranchName}`;
        },
        getCustomCell3Detail(rowData) {
            return `${rowData.familyName}`;
        },
        setDatesDetail(dates) {
            dates.typeData = this.dates.typeData;
            this.dates = dates;
            this.loading = true;
        },
        dateFilterHandlerDetail(filteredData) {
            this.dataToGridDetail = filteredData.data;
            this.loading = false;
        },
    }
}
</script>
<style scoped> 
    .background {
        background: white !important;
        color: white;
    }
    
    /* Mejoras de responsividad para el contenedor */
    .versatile-filter-container {
        width: 100%;
        overflow-x: hidden;
    }
    
    /* Media queries para dispositivos móviles */
    @media (max-width: 600px) {
        .v-radio-group {
            margin: 8px 12px !important;
        }
        
        .v-radio-group .v-radio {
            margin-bottom: 4px;
        }
        
        .v-tabs .v-tab {
            font-size: 0.875rem;
            padding: 0 8px;
        }
        
        .versatile-filter-container {
            padding: 0 4px;
        }
    }
    
    @media (max-width: 960px) and (min-width: 601px) {
        .v-radio-group {
            margin: 12px 16px !important;
        }
        
        .v-tabs .v-tab {
            font-size: 0.9rem;
        }
    }
</style>
<style>
    .dx-datagrid-rowsview .dx-row.dx-group-row td {
        text-align: left !important;
    }

    .hidden-rows .dx-datagrid-content .dx-data-row {
        display: none; /* Oculta todas las filas de datos */
    }
    
    /* Posicionar el selector de sucursal en la línea del filtro */
    .v-input--selection-controls {
        margin-top: 0 !important;
    }
    .dx-datagrid-rowsview .dx-row.dx-group-row td .dx-datagrid-summary-item {
        text-align: center !important;
    }
</style>